/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ site: NonNullable<unknown> }} Practice_Session_Mic_Blocked_Safari_1Inputs */



/**
* | output |
* | --- |
* | "In the menu bar at the top, click Safari and choose Settings for {site}." |
*
* @param {Practice_Session_Mic_Blocked_Safari_1Inputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_mic_blocked_safari_1 = /** @type {((inputs: Practice_Session_Mic_Blocked_Safari_1Inputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Mic_Blocked_Safari_1Inputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Klik bovenaan in de menubalk op Safari en kies Instellingen voor ${i?.site}.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Dans la barre des menus en haut, cliquez sur Safari puis choisissez Réglages pour ${i?.site}.`)
	return /** @type {LocalizedString} */ (`In the menu bar at the top, click Safari and choose Settings for ${i?.site}.`)
});